module.exports = __webpack_public_path__ + "static/comprehensive-image-protection-5972cf99eca89969c078118ede6322cd.png";